<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="vip" ref="headerRef"></HeaderRow>
				<div class="banner" v-if="navList[6]&&navList[6].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[6].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/vip">会员中心</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="containerDiv">
					<!-- 个人信息区 -->
					<div class="profile-section" @click="showLogin">
						<div class="avatar-box">
							<img v-if="$store.state.auth.avatar" :src="$store.state.auth.avatar" alt="">
							<img v-else src="@/assets/placeholder.jpg" />
						</div>
						<div class="info-box">
							<h2 v-if="$store.state.auth.token"> {{ $store.state.auth.nickname||'昵称' }} </h2>
							<h2 v-else>请点击登录</h2>
							<p>{{Phone($store.state.auth.mobile||'188****8888')}}</p>
							<p class="meta" v-if="$store.state.auth.is_vip==1">
								<span>会员</span>有效期至
								{{$store.state.auth.vip_date||'**'}}
							</p>
							<p v-else><span>未开通</span></p>
						</div>
					</div>

					<!-- 会员订阅区 -->
					<div class="subscription-section" v-if="list&&list.length">
						<h3 class="section-title">会员套餐</h3>
						<div class="plan-grid">
							<div v-for="(plan,index) in list" :key="index" class="plan-card">
								<div class="plan-header">
									<h4>{{ plan.name }}</h4>
								</div>
								<div class="price-box">
									<span>¥{{ plan.price }}</span>
								</div>
								<div class="price-remark">
									<span>{{ plan.remark }}</span>
								</div>
								<button class="subscribe-btn" @click="openVip(plan)">
									开通
								</button>
							</div>
						</div>
					</div>
					<!-- 开通记录区 -->
					<div class="subscription-section" v-if="orderList&&orderList.length">
						<h3 class="section-title">开通记录</h3>
						<div class="section-list">
							<div v-for="(item,index) in orderList" :key="index" class="item">
								<div class="item-header">
									<h4>订单号：{{ item.order_no }}</h4>
									<span>{{ ['未支付','已支付','已失效'][item.status]}}</span>
								</div>
								<div class="item-info">
									<div class="info">
										<span>{{ item.card.name }}</span>
										<span>套餐名称</span>
									</div>
									<div class="info">
										<span>{{ item.card.remark }}</span>
										<span>套餐介绍</span>
									</div>
									<div class="info">
										<span>¥{{ item.card.price  }}</span>
										<span>套餐价格</span>
									</div>
									<div class="info">
										<span>{{ item.create_time }}</span>
										<span>下单时间</span>
									</div>
									<div class="info">
										<span>{{ item.pay_time||'-' }}</span>
										<span>支付时间</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 开通说明区 -->
					<div class="notice-section">
						<h3 class="section-title">购买须知</h3>
						<div class="notice-content">
							<ol>
								<li v-for="(item,index) in notices" :key="index">{{ item }}</li>
							</ol>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
		<CashierDialog ref="cashierRef" />
		<TellBindDialog ref="tellBindRef" @onSuccess="onBindSuccess" />
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";
	import CashierDialog from "@/components/cashierDialog.vue";
	import TellBindDialog from "@/components/tellBindDialog.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
			CashierDialog,
			TellBindDialog
		},
		computed: {
			Phone() {
				return (phone) => phone.substring(0, phone.length - 8) + ' ' + '****' + ' ' + phone.substring(phone.length - 4);
			},
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>